document.addEventListener('DOMContentLoaded', function() {
  // Load jQuery UI if not already loaded
  if (typeof jQuery.ui === 'undefined') {
    var script = document.createElement('script');
    script.src = 'https://code.jquery.com/ui/1.12.1/jquery-ui.min.js';
    script.integrity = 'sha256-VazP97ZCwtekAsvgPBSUwPFKdrwD3unUfSGVYrahUqU=';
    script.crossOrigin = 'anonymous';
    document.head.appendChild(script);
    
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://code.jquery.com/ui/1.12.1/themes/base/jquery-ui.css';
    document.head.appendChild(link);
    
    script.onload = initDatePicker;
  } else {
    initDatePicker();
  }
  
  function initDatePicker() {
    $("#event-date").datepicker({
      minDate: 1, // Start from tomorrow
      maxDate: '+3M', // Allow booking up to 3 months in advance
      dateFormat: 'yy-mm-dd',
      onSelect: function(dateText) {
        updateCartAttributes();
      }
    });
    
    // Handle time selection change
    $("#event-time").on('change', function() {
      updateCartAttributes();
    });
    
    // Function to update cart attributes via AJAX
    function updateCartAttributes() {
      var date = $("#event-date").val();
      var time = $("#event-time").val();
      
      if (date && time) {
        $.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: {
            attributes: {
              'Event Date': date,
              'Event Time': time
            }
          },
          dataType: 'json',
          success: function(cart) {
            console.log('Cart attributes updated successfully');
          },
          error: function(error) {
            console.error('Error updating cart attributes:', error);
          }
        });
      }
    }
  }
  
  // Add validation before adding to cart
  $('form[action="/cart/add"]').on('submit', function(e) {
    var date = $("#event-date").val();
    var time = $("#event-time").val();
    
    if (!date || !time) {
      e.preventDefault();
      alert('Please select both a date and time before adding to cart.');
      return false;
    }
  });
});
